<template>
  <v-card>
    <v-card-title class="pr-2" :style=" { backgroundColor: companyPrimaryColor }">
      <h2 style="color:white">Voeg een nieuwe vraag toe</h2>
      <v-spacer></v-spacer>
      <v-btn icon dark @click="closeAddQuestionDialog()">
        <v-icon dark color="white">close</v-icon>
      </v-btn>
    </v-card-title>

    <v-alert
      class="ma-0 pa-2"
      v-if="feedback"
      :value="true"
      type="warning"
    >
    {{ feedback }} 
    </v-alert>

    <v-divider></v-divider>

    <v-card-text>
      <v-form  ref="AddQuestionForm" lazy-validation>
        <v-select
          class="mt-4"
          outlined
          :color="companyPrimaryColor"
          :item-color="companyPrimaryColor"
          hide-details
          label="Stage"
          v-model="newQuestion.stageId"
          prepend-inner-icon="info"
          :rules="rules.required"
          background-color="background"
          :items="stages"
          item-text="name"
          item-value="id"
          required
        ></v-select>
        <v-select
          class="mt-4"
          outlined
          :color="companyPrimaryColor"
          :item-color="companyPrimaryColor"
          hide-details
          background-color="background"
          label="Vraagtype"
          v-model="newQuestion.type"
          prepend-inner-icon="comment"
          :items="questionTypes"
          item-text="label"
          item-value="value"
          hint="Selecteer het vraagtype"
          persistent-hint
          >
        </v-select>
        <v-select
          class="mt-4"
          outlined
          :color="companyPrimaryColor"
          :item-color="companyPrimaryColor"
          background-color="background"
          v-if="activeJourney.type != 'global'"
          label="Filalen"
          v-model="newQuestion.branches"
          prepend-inner-icon="business"
          :items="branches"
          item-text="branchName"
          item-value="id"
          hint="Selecteer de vestigingen waar deze vraag van toepassing is."
          persistent-hint
          multiple
          v-on:input="createBranchesObject()"
          >
        </v-select>

        <!-- QUESTION -->

        <div class="question-wrapper clear" v-for="(language,index) in activeJourney.selectedLanguages" :key="index">
          <div class="language-flag-wrapper">
              <div class="question-language-flag" v-bind:class="language"></div>
          </div>
          <div class="questionfield-wrapper">
            <v-text-field
              class="mt-4"
              outlined
              :color="companyPrimaryColor"
              hide-details
              label="Vraag"
              background-color="background"
              v-model="newQuestion.question[language]"
              :rules="rules.required"
              counter
              maxlength="100"
              required
            ></v-text-field>
          </div>
        </div>

        <v-switch
          class="pa-0 ma-0 mt-4"
          :color="companyPrimaryColor"
          label="Actief"
          v-model="newQuestion.active"
        ></v-switch>
      </v-form>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>
      <v-container grid-list-md fluid class="ma-0 pa-0">
        <v-layout row wrap class="ma-0 pa-0">
          <v-flex xs12 md6 class="text-left" v-if="$vuetify.breakpoint.name != 'sm' && $vuetify.breakpoint.name != 'xs'">
            <v-btn
              outlined
              depressed
              color="#8B93A6"
              @click="closeAddQuestionDialog()"
              >
              Annuleren
            </v-btn>
          </v-flex>
          <v-flex xs12 md6 class="text-right">
            <v-btn
              dark
              rounded
              :block="$vuetify.breakpoint.name == 'sm' || $vuetify.breakpoint.name == 'xs'"
              :color="companySecondaryColor"
              @click="addQuestion()"
              >
              Vraag toevoegen
              <v-icon right dark>chevron_right</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-actions>

  </v-card>
</template>


<script>
import db from "../../firebase/init";
import firebase from "firebase/app";;

export default {
  name: "add-question-form",
  props: {
    branches: Array,
    stages: Array,
    questions: Array,
    activeJourney: Object,
    activeComp: Object
  },

  data() {
    return {
      selectedLanguage: "nl",
      languages: [
        {
          code: "nl",
          name: "Nederlands"
        },
        {
          code: "en",
          name: "Engels"
        }
      ],
      newQuestion: {
        stageId: "",
        active: true,
        type: "rating",
        branchesObject: {},
        question: {
          nl: "",
          en: ""
        }
      },
      feedback: null,
      questionTypes: [
        {
          label: "Beoordeling 1/5",
          value: "rating"
        },
        {
          label: "Feedback achterlaten via tekstveld",
          value: "feedback"
        }
      ],
      rules: {
        required: [v => !!v || "Dit veld is verplicht"],
        counter: value => value.length <= 100 || "Max 100 characters"
      }
    };
  },

  methods: {
    closeAddQuestionDialog() {
      this.$emit("newQuestionDialogChange", false);
    },

    createBranchesObject() {
      this.newQuestion.branchesObject = {};
      let selectedBranchesArray = this.newQuestion.branches;
      let selectedBranchesObject = this.newQuestion.branchesObject;

      selectedBranchesArray.forEach(branch => {
        selectedBranchesObject[branch] = true;
      });
    },

    addQuestion() {
      if (this.newQuestion.stageId && this.newQuestion.question) {
        const order = this.questions.length;
        db.collection("questions")
          .add({
            compId: this.activeComp.id,
            stageId: this.newQuestion.stageId,
            question: this.newQuestion.question,
            type: this.newQuestion.type,
            journeyId: this.activeJourney.id,
            order: order,
            branches: this.newQuestion.branchesObject,
            active: this.newQuestion.active
          })
          .then(() => {
            db.collection("log")
              .add({
                time: new Date(),
                logType: "info",
                user: this.userFirstName + " " + this.userLastName,
                userType: this.userRole,
                company: this.userCompany,
                actionType: "User Action",
                action: "Journey Vraag toegevoegd: " + this.activeComp.name,
                extra:
                  "<b>Vraag:</b> " +
                  this.newQuestion.question +
                  "<br>" +
                  "<b>Actief:</b> " +
                  this.newQuestion.active +
                  "<br>" +
                  "<b>Type:</b> " +
                  this.newQuestion.type +
                  "<br>" +
                  "<b>Branches:</b> " +
                  JSON.stringify(this.newQuestion.branches) +
                  "<br>" +
                  "<b>journeyId:</b> " +
                  JSON.stringify(this.activeJourney.id)
              })
              .catch(error => {
                console.error("Error logging new branch: ", error);
              });
          })
          .then(() => {
            
            this.closeAddQuestionDialog();
            this.newQuestion.stageId = null;
            this.newQuestion.type = "rating";
            this.newQuestion.question = {};
            this.newQuestion.question.nl = null;
            this.newQuestion.question.en = null;
            this.newQuestion.branches = [];
            this.newQuestion.branchesObject = {};
            this.newQuestion.active = true;
            this.$emit("updateData");
            console.log("Question succesfully added");
          })
          .catch(error => {
            console.error("Error adding Question document: ", error);
            db.collection("log").add({
              time: new Date(),
              logType: "error",
              user: this.userFirstName + " " + this.userLastName,
              userType: this.userRole,
              company: this.userCompany,
              actionType: "User Action",
              action: "Error adding Question: " + this.activeComp.name,
              extra: JSON.stringify(error)
            });
          });
      } else {
        this.feedback = "Vul alle velden in om een vraag toe te voegen";
      }
    }
  },
  computed: {
    userRole() {
      return this.$store.state.userRole;
    },
    userCompanies() {
      return this.$store.state.userCompanies;
    },
    userCompany() {
      return this.$store.state.userCompany;
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    }
  }
};
</script>
